import { Box, CssBaseline, SwipeableDrawer, styled } from "@mui/material";
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

interface BasicMobileDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    height?: string | number;
    header?: JSX.Element;
    children: JSX.Element;
}

const BasicMobileDrawer: FC<BasicMobileDrawerProps> = observer(({ isOpen, onClose, header = undefined, children, height = "86%" }) => {

    return (
        <>
            <CssBaseline />
            <SwipeableDrawer
                sx={{
                    ".MuiDrawer-paper ": {
                        borderTopLeftRadius: 14,
                        borderTopRightRadius: 14,
                        height: height
                    },

                }}
                anchor="bottom"
                open={isOpen}
                onClose={onClose}
                onOpen={() => { }}
                disableSwipeToOpen
                ModalProps={{
                    keepMounted: false,
                }}
            >
                <Box
                    pl={1}
                    pt={1}
                    sx={(theme) => ({
                        position: 'relative',
                        border: 9,
                        // backgroundColor: theme.palette.primary.main,
                        borderColor: "white",
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        visibility: 'visible',
                        right: 0,
                        left: 0,
                    })}
                >
                    <Puller />
                    {header && header}
                </Box>
                {children}
            </SwipeableDrawer >
        </>
    )
})

export default BasicMobileDrawer;

const Puller = styled(Box)(({ theme }) => ({
    width: 52,
    height: 6,
    zIndex: 1,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 50,
    border: `1px solid ${theme.palette.grey[300]}`,
    position: 'absolute',
    top: -3,
    left: 'calc(50% - 26px)',
}));